import React, { lazy, Suspense } from "react";
import { useCart } from "@/contexts/CartContext";
import { prefetchIdle, isDirectProductEntry } from "@/lib/sitePrefetch";

const loadCartDrawer = () => import("@/components/CartDrawer");
const CartDrawer = lazy(loadCartDrawer);

/**
 * Carrinho só monta (e só busca frete/brindes/embalagens) depois da 1ª abertura.
 * Código baixado em tempo ocioso, exceto quando a visita entra direto num produto
 * (aí só por abertura, para não disputar a 1ª foto).
 */
const DeferredCartDrawer = () => {
  const { isCartOpen } = useCart();
  const [mounted, setMounted] = React.useState(isCartOpen);
  React.useEffect(() => { if (isCartOpen) setMounted(true); }, [isCartOpen]);
  React.useEffect(() => { if (!isDirectProductEntry()) prefetchIdle([loadCartDrawer]); }, []);
  return mounted ? <Suspense fallback={null}><CartDrawer /></Suspense> : null;
};

export default DeferredCartDrawer;
